export default function secretQuesReducer(state = { secretQues: [], quesReceived: false }, action) {
    switch (action.type) {
        case 'SECRET_QUES':
            return {
                secretQues: action.secretQues,
                quesReceived: action.quesReceived
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/secret_ques.jsx